import { Injectable } from '@angular/core';

@Injectable()
export class ToastService {
  constructor() {}

  showOk(textParam, durationParam, styleParam): any {
    const text = textParam ? textParam : 'ok';
    const duration = durationParam ? durationParam : 3000;
    const style = styleParam ? styleParam : 'glicon-checkmark blue-text font-s-big';
  }

  showError(textParam, durationParam, styleParam): any {
    const text = textParam ? textParam : 'ko';
    const duration = durationParam ? durationParam : 3000;
    const style = styleParam ? styleParam : 'glicon-cross orange-lighten-3 font-s-big';
  }
}
